import React, {Component} from 'react';
import { connect } from "react-redux";
//import Toolbar from '@material-ui/core/Toolbar';
//import {makeStyles } from '@material-ui/core/styles';
/* import Button from "@material-ui/core/Button";
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar' */
import { Card, CardGroup} from 'react-bootstrap';
import Grid from '@material-ui/core/Grid';
import 'bootstrap/dist/css/bootstrap.min.css';
import HistogramPlot from "./HistogramPlot";
import RiskView from "../RiskView/RiskView" //"../Components/RiskView/RiskView";
import * as jsonCall from "../../Algorithms/JSONCall";
import Button from '@material-ui/core/Button';
import _ from 'lodash';
import * as d3 from "d3";
import Radio from '@material-ui/core/Radio';
//import * as d3 from "d3"
//import * as $ from "jquery"
//import databankv5_individual from "../src/data/databankv5_individual.csv"
import aggregate_data_json from "../../data/databankv5_aggregate_bins.json";//"../src/data/databankv5_aggregate_bins.json"
import "./../../App.css";

/* const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
})); */

export class Plots extends Component {
  //const classes = useStyles();
  constructor(props) {
    super(props);
    this.handleRadioClick = this.handleRadioClick.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    console.log();
  }
  componentDidMount() {
    jsonCall.download(this.props.url + "/api/v2/histograms", {dataset_type:this.props.dataset_type}).then(res =>{this.props.set_agg_data(res)})
    
  }

  handleRadioClick=(event)=>{
    console.log(event.target.value);
    this.props.set_clicked_agg_dataset(event.target.value);
    //var temp = selected_attributes_of_interest.map(d=>d.value);
    //this.props.set_attributes_of_interest_temp(temp)
  }
  handleButtonClick=(event)=>{
    console.log(this.props.clicked_agg_dataset);
    var mylist = [this.props.clicked_agg_dataset];
    var big_list =[];
    //var all_individual_datasets = ["Crime Reports", "Arrest Data from 2010 to 2019", "Crime Data from 2010 to 2019", "Crime Data from 2020 to Present", "Traffic Collision Data from 2010 to Present", "Sex Offenders", "Police Incidents", "Police Unknown Suspects"];
    var all_individual_datasets = ["Motor Vehicle Collisions - Crashes","NYPD Complaint Data Historic","NYPD Arrest Data (Year to Date)","NYPD Complaint Data Current (Year To Date)","NYPD Arrests Data (Historic)","NYPD Shooting Incident Data (Historic)","Crime Reports","L&I Apprenticeship Apprentice Details","Arrest Data from 2010 to 2019","Crime Data from 2010 to 2019","Crime Data from 2020 to Present","Traffic Collision Data from 2010 to Present","State of Iowa Salary Book","Offenders Released from Iowa Prisons","3-Year Recidivism for Offenders Released from Prison in Iowa","Iowa Juvenile Detention Secure Placements","Closed Discrimination Complaint Cases in Iowa","3-Year Recidivism for Offenders Admitted to Probation in Iowa","KCPD Crime Data 2020","KCPD Crime Data 2014","KCPD Crime Data 2015","KCPD Crime Data 2018","KCPD Crime Data 2019","KCPD Crime Data 2016","KCPD Crime Data 2017","Lobbyist Data - Historical - Lobbyist Registry - 2010","Public Chauffeurs","Sex Offenders","State Employee Payroll Data Calendar Year 2015 through Present","Accidental Drug Related Deaths 2012-2020","Accused Pre-Trial Inmates in Correctional Facilities","Racial Profiling Prohibition Project Traffic Stop Data - ARCHIVE","Base Provider Enrollment File","Police Incidents","Police Unknown Suspects","Police Arrests","Police Person","911 Calls Burglary","Dallas Police Public Data RMS Arrest with GeoLocation Temporary","Use Of Force","SPD Officer Involved Shooting (OIS) Data","Terry Stops","Daily Arrests","Traffic Violations","Police Incidents Mesa","Fire and Medical Opioid Overdose Incidents","Mass Payments","Deputy Details - Hit Shooting Incidents and Non-Hit Shooting Incidents 2010 to Present","Hit Shooting Incidents and Non-Hit Shooting Incidents 2010 to Present","Person Details - Hit Shooting Incidents and Non-Hit Shooting Incidents 2010 to Present","COVID-19 Case Surveillance Public Use Data","Provisional COVID-19 Deaths: Focus on Ages 0-18 Years","CDC - COVID 19 Case Surveillance Public Use Data","HCM Employees","Overdose Information Network Data CY January 2018 - Current Monthly County State Police","Evanston Arrests","Traffic Stops in Evanston","Evanston Citations","Evanston Field Contacts","Officer Involved Shooting","City of Tacoma Hate Bias (2013-2021)","Police Department Crash Data - Updated","Providence Police Department  Arrests and Citations- Past 60 Days","Certified Vendors - Office of Supplier Diversity","Rate PUF - 2015","Rate PUF - 2014","Rate PUF 2016","Police Department Incidents (2010 - 6/3/2021)","Fire Department Incidents (2010 - Current Year)","Crime Responses","Traffic Crashes","Arrests Gainesville","Adult Arrests","Arrests","Citations","FLPD Employee Info","Juvenile Arrests","Electronic Police Report 2018","Electronic Police Report 2019","Electronic Police Report 2016","Electronic Police Report 2017","NOPD Misconduct Complaints","NOPD Use of Force Incidents","Electronic Police Report 2015","STD Screenings","City of Hartford Birth Information 2002 - 2012","Community Policing Data July 1, 2020 to March 31, 2021","Traffic Crash Reports (CPD)","City of Cincinnati Employees w/ Salaries","PDI (Police Data Initiative) Crime Incidents","PDI (Police Data Initiative) Use of Force","PDI (Police Data Initiative) CPD Shootings","PDI (Police Data Initiative) Officer Involved Shootings","Economic Inclusion Certified Vendors - MBE/WBE Program","PDI (Police Data Initiative) Assaults on Officers","PDI (Police Data Initiative) Traffic Stops (Drivers)","PDI (Police Data Initiative) Traffic Stops (All Subjects)","Citizen Complaint Authority (CCA) Closed Complaints","Crime Incident Report - Dataset","Traffic Stop Dataset","Pedestrian And Bike Crash Data - Dataset","Saint Paul Police Department Citations","City Court Warrants","Legacy City-Parish Employees","City-Parish Employees","Armored Rescue Vehicle Use","Citizen Complaints","Hate Crimes","Police Active Warrants","Police Arrest Reports","Employee Demographics","BPD Arrests","OPD Crimes","OPD Officer-Involved Shootings","OPD Response To Resistance","Hate Crimes Data","Crimes","Motor Vehicle Crash Reports","APD Arrests Dataset by Neighborhood","APD LEAD Dataset","APD Arrests Dataset by Patrol Zone","APD Field Interview Cards Dataset by Neighborhood","APD Traffic Citations by Neighborhood","APD Traffic Citations by Patrol Zone","Mesa Police Uniform Crime Reporting Statistics- Part 1 Crimes For 2017","Mesa Police Uniform Crime Reporting Statistics- Part 1 Crimes For 2017-2","Overdose Information Network Data Current County State Police","Use of Force Reports","Arrest Data with all Offenses and Demographic Detail","Crash Data","Arrest Data Subject Level","Officer Involved Shootings","Ticket and Citation Data with Charges","Ticket And Citation Data with Demographics","Urbana Police Arrests Since 1988","Urbana Police Traffic Stops - since 2012","IDOT Stop Sheets","Macoupin County - Payroll","DUI DATA","DRUG ARRESTS","Medical Examiner Archive URL Import","FFP Payroll 2019","2017-2019 Payroll Report 18feb2019","Current Traffic Accidents","Vehicle  Accident Data","Daily Inmates In Custody","Inmate Admissions","Inmate Discharges","NYPD Criminal Court Summons Incident Level Data (Year To Date)","NYPD Criminal Court Summons (Historic)","NYPD Shooting Incident Data (Year To Date)"]
    for(var x of all_individual_datasets){
      var temp = [mylist[0],x]
      big_list.push(temp);
    }
    //var temp = selected_attributes_of_interest.map(d=>d.value);
    console.log(big_list);
    d3.selectAll(".attributes_xaxis").remove();
    this.props.set_dataset_combinations(big_list);
  }
  sort_object_custom = (dict) => {
    var items = Object.keys(dict).map(function (key) {
      return [key, dict[key]]; //["A",[4,2]], [DatasetName, [lowest_bin, dangerous_bins]]
    });
    items.sort(function (first, second) {
      return second[1][1] - first[1][1] || first[1][0] - second[1][0]; //sort descending by number of dangerous bins, then sort ascending by the lowest size of bin for each dataset
    });
    return items;
  }
  render(){
    console.log(Object.keys(this.props.agg_data).length);
    if(Object.keys(this.props.agg_data).length !== 0 || this.props.agg_data !== undefined){
    //var attr = ["age", "gender", "race"];
    var attr = this.props.attributes_of_interest;
    console.log("Number of Datasets ",(this.props.dataset_list).length);
    var dataset_list1 = this.props.dataset_list;
    var datasets = ["Demographics for Public Health, Policy, and Planning",  "Demographics for Public Health, Policy, and Planning"];
    //finding datasets to be plot
    var portals = this.props.selected_portals;
    var new_agg_data = _.pickBy(this.props.agg_data,function(d){
      return portals.includes(d["domain"]);
    }); //this has the agg data filtered by the selected portals
    var datasets2 =  Object.keys(new_agg_data); //only the keys from the agg_data
    var data1 = Object.values(new_agg_data).map((d,i) =>{if(attr.every(elem =>d["attr_found"].includes(elem))){return i;} else{return -1}}); //checking of all the selected attributes are present or not, returns -1 for no presence and returns the index for presence
    var data2 = data1.filter(word => word !== -1); //array of index for all the datasets where they are present
    console.log(data2);
    var datasets3 = _.at(datasets2,data2); //names of the datasets where all the attributes are present
    var datasets4 = datasets3.filter(function(item) {
      /* console.log(dataset_list1);
      console.log(item, typeof(item), dataset_list1.includes(item)); */
      return dataset_list1.includes(item); 
    });
    
    var dataset_dict = {};
    var threshold = this.props.threshold_k; //k of k-anonymity
    for(var i of datasets4){
      var dangerous_bins = 0;
      var lowest_bin = 99999999;
      var attr_to_traverse = (new_agg_data[i]["attr_found"]).filter(d => attr.includes(d));
      for(var j of attr_to_traverse){
        var list_values = Object.values(new_agg_data[i][j]);
        var lowest = Math.min(...list_values);
        lowest_bin = Math.min(...[lowest, lowest_bin]); //finding the lowest bin of that dataset
        dangerous_bins += (list_values.filter(d => d<=threshold)).length; //number of bins lower than the threshold
      }
      dataset_dict[i] =[lowest_bin,dangerous_bins];
      /* dataset_dict[i]["lowest_bin"] = lowest_bin;
      dataset_dict[i]["dangerous_bins"] = dangerous_bins; */
    } //end of lowest_bin calculation
    console.log(this.sort_object_custom(dataset_dict));
    var datasets5 = (this.sort_object_custom(dataset_dict)).map(d =>d[0]);

    
    datasets = datasets5;
    /* console.log(datasets2)
    console.log(data1);
    console.log(data2);
    console.log(datasets3);
    console.log(datasets4);
    console.log(datasets); */

  return (
   
    
  <Card.Body style={{height: 560, overflowY: "scroll"}}>
   {(datasets.length>0)?datasets.map((item_big,index_big) =>{
     return <Grid container direction="row" spacing={3}>
     <Grid item xs={3} sm={3}>
       <Grid container>
       <Grid item xs={3} sm={3}>
       {/* <Radio
         //checked={false}
         onChange={this.handleRadioClick} 
         value={item_big}
         color="default"
         name="radio-button"
         inputProps={{ 'aria-label': 'D' }}
       /> */}
       <input
       type="radio"
       onChange={this.handleRadioClick} 
       value={item_big}
       name="radio-button"
       style={{ marginTop:"200%" }}
       ></input>
       </Grid>
       <Grid item xs={9} sm={9}><div style={{ marginTop:"40%" }}>{item_big}</div></Grid>
       </Grid>
       </Grid>
       
                         {attr!=null?attr.map((item,index) => {
                           //console.log(new_agg_data[item_big]);
                             return <Grid item xs={3} sm={3} id={"grid_"+index_big+"_"+index}>
                                 {new_agg_data[item_big]!==(null || undefined)?<HistogramPlot myid={"chart_"+index_big+"_"+index} title={item} item={item} index={index} index_big={index_big} agg_data={new_agg_data[item_big][item]} threshold_k={this.props.threshold_k}></HistogramPlot>:null}
                             </Grid>
                         }):null}
        </Grid>
   }):<p>No dataset has these combination of attributes</p>} 

<Button style={{position:'sticky',bottom:0,width:'100%',backgroundColor:'#bcbcbc',padding:0}}
                    variant="secondary"
                    disabled={this.props.isLoadingMatches}
                    onClick={this.handleButtonClick}
                > {this.props.isLoadingMatches ? 'Loading…' : 'Show Risks'}
                </Button>
  
      {/* <HistogramPlot myid={"chart"+index} title={item} hist_data={this.props.hist_data}></HistogramPlot> */}
  </Card.Body>
  

  

    
  );
                      }
}
}

const maptstateToprop = (state) => {
  return {
    url: state.url,
    original_data: state.original_data,
    agg_data: state.agg_data,
    clicked_agg_dataset:state.clicked_agg_dataset,
    attributes_of_interest: state.attributes_of_interest,
    dataset_list: state.dataset_list,
    dataset_type: state.dataset_type,
    threshold_k: state.threshold_k,
    selected_portals:state.selected_portals,
  }
}
const mapdispatchToprop = (dispatch) => {
  return {
    set_original_data: (val) => dispatch({ type: "original_data", value: val }),
    set_agg_data: (val) => dispatch({ type: "agg_data", value: val }),
    set_clicked_agg_dataset: (val) => dispatch({ type: "clicked_agg_dataset", value: val }),
    set_selected_datasets: (val) => dispatch({ type: "selected_datasets", value: val }),
    set_dataset_combinations: (val) => dispatch({ type: "dataset_combinations", value: val }),

  }
}
export default connect(maptstateToprop, mapdispatchToprop)(Plots);
